import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Languages } from "lucide-react";

const LABELS = { fr: "FR", ar: "AR", en: "EN" };
const FULL = { fr: "Français", ar: "العربية", en: "English" };

export const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const current = (i18n.language || "fr").split("-")[0];
  const change = (lang) => i18n.changeLanguage(lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher-btn"
          className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg hover:bg-black/5 transition-colors text-sm ${
            compact ? "h-8" : ""
          }`}
        >
          <Languages className="w-4 h-4" strokeWidth={1.5} />
          <span className="font-medium tracking-wide">{LABELS[current] || "FR"}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {Object.entries(FULL).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => change(code)}
            data-testid={`lang-option-${code}`}
            className={current === code ? "bg-[#D6202C]/10 text-[#D6202C] font-medium" : ""}
          >
            <span className="w-6 text-xs font-mono">{LABELS[code]}</span>
            <span className="ml-2">{label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
